import { Injectable } from '@angular/core';
import { DrupalRESTService } from './drupal-rest.service';
import { Observable } from 'rxjs';
import { EntityRESTService } from './entity-rest.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userEndpoint = '/api_user/v1/access';

  constructor(
    private _drupalRESTService: DrupalRESTService,
    private _entityRESTService: EntityRESTService,
    private _snackBar: MatSnackBar,
    ) {}

  // Method to get a user or users
  getUsers(params: any): Observable<any> {
    return this._drupalRESTService.httpGET(this.userEndpoint, params);
  }

  // Method to create a new user
  createUser(userData: any): Observable<any> {
    return this._drupalRESTService.httpPOST(this.userEndpoint, userData);
  }

  // Method to update a user
  updateUser(userId: string, userData: any): Observable<any> {
    const updateEndpoint = `${this.userEndpoint}`;
    return this._drupalRESTService.httpPATCH(updateEndpoint, userData);
  }

  // Self-service update of the current user's own UI language preference.
  // Uses the account_info endpoint (scoped to the current user) so any logged-in
  // user can save their own language without the admin-oriented user_resource
  // PATCH permission. skipStudioReference keeps the studio auto-injection off a
  // non-studio-scoped account endpoint.
  savePreferredLanguage(langcode: string): Observable<any> {
    return this._drupalRESTService.httpPATCH('/api/account', { preferred_langcode: langcode }, undefined, { skipStudioReference: true });
  }

  // Newest What's New month (YYYY-MM) the current user has opened.
  saveWhatsNewSeen(month: string): Observable<any> {
    return this._drupalRESTService.httpPATCH('/api/account', { whats_new_seen: month }, undefined, { skipStudioReference: true });
  }

  // Method to delete a user
  deleteUser(id: number) {
    return new Observable((observer) => {
      this._entityRESTService.deleteEntity('user', '', id).subscribe(
        () => {
          this.getUsers({});
          observer.next();
          observer.complete();
        },
        error => {
          LoggerService.error('Error deleting user:', error);
          this._snackBar.open('Error deleting user. ' + error?.statusText, 'Close', { duration: 3000 });
          observer.error(error);
        }
      );
    });
  }
}
